import { render } from "./MessageDisplay.vue?vue&type=template&id=d4d0e5bc"
import script from "./MessageDisplay.vue?vue&type=script&lang=js"
export * from "./MessageDisplay.vue?vue&type=script&lang=js"

import "./MessageDisplay.vue?vue&type=style&index=0&id=d4d0e5bc&lang=less"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__